import { type User } from '$/services/usecases/authentication/mapper/genericCloudResponse';

export const userRoleDefinition: Record<
  NonNullable<User['role']>,
  { translation: string; mockProjects: number; projectLimit: number }
> = {
  free: {
    translation: 'roles.free' as const,
    mockProjects: 0,
    projectLimit: 0,
  },
  pro: {
    translation: 'roles.pro' as const,
    mockProjects: 8,
    projectLimit: 1000,
  },
  keyUser: {
    translation: 'roles.keyUser' as const,
    mockProjects: 8,
    projectLimit: 1000,
  },
  countryAdmin: {
    translation: 'roles.countryAdmin' as const,
    mockProjects: 8,
    projectLimit: 1000,
  },
  superAdmin: {
    translation: 'roles.superAdmin' as const,
    mockProjects: 8,
    projectLimit: 1000,
  },
  student: {
    translation: 'roles.student' as const,
    mockProjects: 0,
    projectLimit: 1000,
  },
  teacher: {
    translation: 'roles.teacher' as const,
    mockProjects: 0,
    projectLimit: 1000,
  },
  superTeacher: {
    translation: 'roles.teacher' as const,
    mockProjects: 0,
    projectLimit: 1000,
  },
};

export type UserRole = keyof typeof userRoleDefinition;
